import { ProductTypeType } from "types/Product";

export const getProductTypes = (productTypes: ProductTypeType[]): string =>
  productTypes
    ? productTypes.reduce((result: string, type: { value: string }, index: number) => {
        return index ? `${result}, ${type.value}` : result + type.value;
      }, "")
    : "";
